import { Activity, PersonStanding } from 'lucide-react';
import CalisthenicsIcon from './CalisthenicsIcon';

const PILLARS = [
  { Icon: Activity, label: 'Mobility' },
  { Icon: CalisthenicsIcon, label: 'Calisthenics' },
  { Icon: PersonStanding, label: 'Aesthetics' },
] as const;

export default function PillarRow() {
  return (
    <div className="flex items-start justify-center gap-14 sm:gap-20">
      {PILLARS.map(({ Icon, label }) => (
        <div key={label} className="flex flex-col items-center gap-4">
          <Icon size={32} strokeWidth={1.5} className="text-[#2B2414]" />
          <span
            className="text-[11px] font-semibold uppercase text-[#5E5138] font-body"
            style={{
              letterSpacing: '0.14em',
            }}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
